<template>
  <div class="search-mobile-filter">
    <select v-model="selectValue">
      <option :value="null">All results ({{ count }})</option>
      <option v-for="type in types" :key="type.key" :value="type">
        {{ type.label }} ({{ typeCount[type.key] }})
      </option>
    </select>
    <div class="search-mobile-filter-chevron">
      <i class="fal fa-chevron-down"></i>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
    results: Array
  },
  data() {
    return {
      types: [
        { key: 'article', label: 'News' },
        { key: 'event', label: 'Events' },
        { key: 'startup_import', label: 'Startups' },
        { key: 'page', label: 'Pages' }
      ]
    }
  },
  computed: {
    count() {
      return this.results.length
    },
    typeCount() {
      return this.results.reduce(
        (count, result) => {
          count[result.type]++

          return count
        },
        { article: 0, event: 0, startup_import: 0, page: 0 }
      )
    },
    selectValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>
